import { render, staticRenderFns } from "./Addstudent.vue?vue&type=template&id=c3ec8030&scoped=true"
import script from "./Addstudent.vue?vue&type=script&lang=js"
export * from "./Addstudent.vue?vue&type=script&lang=js"
import style0 from "./Addstudent.vue?vue&type=style&index=0&id=c3ec8030&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3ec8030",
  null
  
)

export default component.exports